// extracted by mini-css-extract-plugin
export default {"title":"ForgotEmailPage_title__fOzfO","description":"ForgotEmailPage_description__P0x0d","input":"ForgotEmailPage_input__f1XvP","button":"ForgotEmailPage_button__WfGUa"};